import type { EnumUnion } from "@dresscode-frontend/utility-types";

import type {
  ConnectionType,
  NetworkItem,
  NetworkType,
} from "@/constants/network";

type NetworkTableAdminContactColumn = {
  id: string;
  avatarUrl?: string;
  name: string;
  email?: string;
};

export const NetworkTableColumns = {
  ID: "ID",
  NETWORK_NAME: "NETWORK_NAME",
  NETWORK_TYPE: "NETWORK_TYPE",
  PURPOSE: "PURPOSE",
  CONNECTION_TYPE: "CONNECTION_TYPE",
  DESTINATION: "DESTINATION",
  ADMIN_CONTACT: "ADMIN_CONTACT",
} as const;

export type NetworkTableColumns = EnumUnion<typeof NetworkTableColumns>;

type PlaceDestination = { id: string; name: string };
type DeviceDestination = { id: string; name: string };
type NetworkDestinationType = NetworkItem["destinationType"];

export type NetworkTableRow = {
  [NetworkTableColumns.ID]: string;
  [NetworkTableColumns.NETWORK_NAME]: string;
  [NetworkTableColumns.NETWORK_TYPE]: NetworkType | undefined;
  [NetworkTableColumns.PURPOSE]: string | undefined;
  [NetworkTableColumns.CONNECTION_TYPE]: ConnectionType | undefined;
  [NetworkTableColumns.DESTINATION]: {
    destinationPlaceContent?: PlaceDestination;
    destinationDeviceContent?: DeviceDestination;
    destinationType: NetworkDestinationType;
  };
  [NetworkTableColumns.ADMIN_CONTACT]: NetworkTableAdminContactColumn;
};

export const convertNetworkItemToTableRow = (
  item: NetworkItem,
): NetworkTableRow => {
  return {
    [NetworkTableColumns.ID]: item.id,
    [NetworkTableColumns.NETWORK_NAME]: item.networkName,
    [NetworkTableColumns.NETWORK_TYPE]: item.networkType,
    [NetworkTableColumns.PURPOSE]: item.purpose,
    [NetworkTableColumns.CONNECTION_TYPE]: item.connectionType,
    [NetworkTableColumns.DESTINATION]: {
      destinationPlaceContent: item.destinationPlaceContent,
      destinationDeviceContent: item.destinationDeviceContent,
      destinationType: item.destinationType,
    },
    [NetworkTableColumns.ADMIN_CONTACT]: {
      id: item.adminContact?.personId || "",
      avatarUrl: item.adminContact?.avatarUrl,
      name: item.adminContact?.name || "",
      email: item.adminContact?.primaryWorkerEmail,
    },
  };
};
